export type StrengthsQuestion = {
  strength: string
  question: string
}

export const questions: StrengthsQuestion[] = [
  {
    strength: 'Appreciation of Beauty and Excellence',
    question:
      'I feel full of wonder when I think about the beauty in the world.',
  },
  {
    strength: 'Appreciation of Beauty and Excellence',
    question: 'I regularly notice the beauty around me.',
  },
  {
    strength: 'Appreciation of Beauty and Excellence',
    question: 'I am often in awe of the goodness I witness.',
  },
  {
    strength: 'Appreciation of Beauty and Excellence',
    question: 'It is important to me to surround myself with beauty.',
  },
  {
    strength: 'Appreciation of Beauty and Excellence',
    question: 'I see the beauty in things that other people overlook.',
  },

  {
    strength: 'Bravery/Courage',
    question: "I don't shy away from necessary tension or discomfort.",
  },
  {
    strength: 'Bravery/Courage',
    question: 'I like to face my fears head-on. ',
  },
  {
    strength: 'Bravery/Courage',
    question: 'Others see me as strong or courageous.',
  },
  { strength: 'Bravery/Courage', question: 'Others see me as brave.' },
  { strength: 'Bravery/Courage', question: 'I stand up for what is right.' },

  { strength: 'Creativity', question: 'I create things that are useful.' },
  {
    strength: 'Creativity',
    question: 'I find unique ways of solving problems.',
  },
  { strength: 'Creativity', question: 'Others see me as creative.' },
  { strength: 'Creativity', question: 'I want to be very original.' },
  { strength: 'Creativity', question: 'I like to think outside-the-box.' },

  { strength: 'Curiosity', question: 'I am an explorer.' },
  { strength: 'Curiosity', question: 'I love trying new things.' },
  { strength: 'Curiosity', question: 'I tend to seek novelty.' },
  { strength: 'Curiosity', question: 'I am open to new experiences.' },
  { strength: 'Curiosity', question: 'I have a lot of different interests.' },

  {
    strength: 'Fairness',
    question: 'I advocate for fair, equal treatment for all.',
  },
  {
    strength: 'Fairness',
    question: "I don't let personal feelings affect my view of others.",
  },
  {
    strength: 'Fairness',
    question: "I treat others the way I'd like to be treated.",
  },
  {
    strength: 'Fairness',
    question: 'I believe everyone should have the same opportunities.',
  },
  { strength: 'Fairness', question: 'I treat everyone equally.' },

  {
    strength: 'Forgiveness/Mercy',
    question: "I accept other people's flaws and shortcomings.",
  },
  {
    strength: 'Forgiveness/Mercy',
    question: 'I am ready to let go of the pain when I am wronged.',
  },
  {
    strength: 'Forgiveness/Mercy',
    question: 'I never seek revenge on others.',
  },
  {
    strength: 'Forgiveness/Mercy',
    question: 'I am quick to give people a second chance.',
  },
  {
    strength: 'Forgiveness/Mercy',
    question: 'I am always willing to hear out an apology.',
  },

  { strength: 'Gratitude', question: 'I express thanks to those around me.' },
  { strength: 'Gratitude', question: 'I never take life for granted.' },
  {
    strength: 'Gratitude',
    question: 'I regularly express how grateful I am.',
  },
  { strength: 'Gratitude', question: 'I am thankful for every day.' },
  { strength: 'Gratitude', question: 'I have been very blessed in life.' },

  { strength: 'Honesty', question: 'I admit when I am in the wrong.' },
  {
    strength: 'Honesty',
    question: 'I always take responsibility for my own actions.',
  },
  {
    strength: 'Honesty',
    question: 'I tell the truth, even when it might affect myself or others.',
  },
  {
    strength: 'Honesty',
    question: 'I am honest with others about who I am.',
  },
  {
    strength: 'Honesty',
    question: 'I see honesty as the primary means to building trust.',
  },

  {
    strength: 'Hope',
    question: 'I constantly work toward a positive future.',
  },
  { strength: 'Hope', question: 'I often expect the best to happen.' },
  {
    strength: 'Hope',
    question: 'There are many ways for me to reach my goals.',
  },
  { strength: 'Hope', question: 'I can always see the good side of things.' },
  {
    strength: 'Hope',
    question: 'I trust that everything will turn out well.',
  },

  {
    strength: 'Humility/Modesty',
    question: 'I allow my accomplishments to speak for themselves.',
  },
  {
    strength: 'Humility/Modesty',
    question: "I don't see myself as more special than others.",
  },
  {
    strength: 'Humility/Modesty',
    question: 'I often keep major achievements to myself.',
  },
  {
    strength: 'Humility/Modesty',
    question: 'I own up to my own imperfections.',
  },
  {
    strength: 'Humility/Modesty',
    question: 'I prefer to focus the attention on other people.',
  },

  { strength: 'Humor', question: 'I connect with others through humor.' },
  { strength: 'Humor', question: 'I love to make others laugh and smile.' },
  {
    strength: 'Humor',
    question: 'I often try to break tension with fun and jokes.',
  },
  { strength: 'Humor', question: 'I am known for being funny.' },
  { strength: 'Humor', question: 'I value my sense of humor.' },

  {
    strength: 'Judgment/Critical Thinking',
    question:
      'I avoid making quick decisions, opting instead to weigh the evidence.',
  },
  {
    strength: 'Judgment/Critical Thinking',
    question: 'I take the time to examine things from all sides.',
  },
  {
    strength: 'Judgment/Critical Thinking',
    question: 'I am an analytical thinker.',
  },
  {
    strength: 'Judgment/Critical Thinking',
    question: 'I enjoy thinking deeply about different topics.',
  },
  {
    strength: 'Judgment/Critical Thinking',
    question: 'I never jump to conclusions.',
  },

  { strength: 'Kindness', question: 'I enjoy helping others.' },
  { strength: 'Kindness', question: 'I readily help those who are in need.' },
  { strength: 'Kindness', question: 'I have compassion for other people.' },
  { strength: 'Kindness', question: 'Others see me as generous.' },
  {
    strength: 'Kindness',
    question: 'I am quick to care for someone who needs help.',
  },

  { strength: 'Leadership', question: 'I enjoy leading others.' },
  {
    strength: 'Leadership',
    question: 'I have a positive influence on other people.',
  },
  {
    strength: 'Leadership',
    question: 'I am good at taking charge of a group project.',
  },
  {
    strength: 'Leadership',
    question: 'Others seem to expect me to lead the group.',
  },
  {
    strength: 'Leadership',
    question:
      "I ask for others' opinions before making decisions that affect the group.",
  },

  {
    strength: 'Love',
    question: 'I am comfortable accepting love from others.',
  },
  {
    strength: 'Love',
    question:
      'I love building new relationships and growing close with other people.',
  },
  {
    strength: 'Love',
    question: 'I pride myself in being warm and genuine to others.',
  },
  { strength: 'Love', question: 'It feels natural to express love.' },
  {
    strength: 'Love',
    question: 'I prioritize my relationships with others.',
  },

  {
    strength: 'Love of Learning',
    question: 'I enjoy deepening my knowledge.',
  },
  {
    strength: 'Love of Learning',
    question: 'I constantly seek opportunities to learn.',
  },
  {
    strength: 'Love of Learning',
    question: 'I go out of my way to learn something new.',
  },
  {
    strength: 'Love of Learning',
    question: 'I have enjoyed learning for as long as I can remember.',
  },
  {
    strength: 'Love of Learning',
    question: 'Learning is a part of my identity.',
  },

  {
    strength: 'Perseverance',
    question: 'I follow through with all of the goals I set.',
  },
  {
    strength: 'Perseverance',
    question: 'I am committed to finishing what I start.',
  },
  {
    strength: 'Perseverance',
    question: 'I am seldom fazed by obstacles in my way.',
  },
  {
    strength: 'Perseverance',
    question: 'I refuse to quit something that I have set out to do.',
  },
  {
    strength: 'Perseverance',
    question:
      'I believe that persevering is one of the most important things in life.',
  },

  {
    strength: 'Perspective/Wisdom',
    question: 'I like to help others better understand the world.',
  },
  {
    strength: 'Perspective/Wisdom',
    question: 'I tend to learn from each mistake. ',
  },
  {
    strength: 'Perspective/Wisdom',
    question: 'I tend to have a good understanding of how the world works.',
  },
  {
    strength: 'Perspective/Wisdom',
    question: 'Other people come to me for advice.',
  },
  {
    strength: 'Perspective/Wisdom',
    question: 'I look at the "big picture".',
  },

  { strength: 'Prudence', question: 'I am cautious.' },
  {
    strength: 'Prudence',
    question: 'I consider how my actions may affect others.',
  },
  { strength: 'Prudence', question: 'I regularly avoid taking big risks.' },
  {
    strength: 'Prudence',
    question:
      'I am careful to think through decisions before committing to a plan.',
  },
  { strength: 'Prudence', question: 'I plan things far in advance.' },

  {
    strength: 'Self-regulation',
    question: 'I carefully manage my bad habits.',
  },
  {
    strength: 'Self-regulation',
    question: 'I closely manage my emotions and impulses.',
  },
  {
    strength: 'Self-regulation',
    question: 'I usually stay calm under pressure.',
  },
  {
    strength: 'Self-regulation',
    question: 'Others see me as highly disciplined.',
  },
  {
    strength: 'Self-regulation',
    question: 'I regularly stay on task at work.',
  },

  { strength: 'Social Intelligence', question: 'I always know what to say.' },
  {
    strength: 'Social Intelligence',
    question: 'I often know what motivates other people.',
  },
  {
    strength: 'Social Intelligence',
    question: "I pay close attention to others' emotions.",
  },
  {
    strength: 'Social Intelligence',
    question: 'I have a good understanding of people.',
  },
  {
    strength: 'Social Intelligence',
    question: 'I know what to do and how to act in social settings.',
  },

  {
    strength: 'Spirituality/Sense of Meaning',
    question:
      'I believe my life is a part of something bigger and more meaningful.',
  },
  {
    strength: 'Spirituality/Sense of Meaning',
    question: 'I have a deep sense of purpose in life.',
  },
  {
    strength: 'Spirituality/Sense of Meaning',
    question: 'I consider myself to be a spiritual person.',
  },
  {
    strength: 'Spirituality/Sense of Meaning',
    question: 'I feel like I have a true calling.',
  },
  {
    strength: 'Spirituality/Sense of Meaning',
    question: 'My spiritual beliefs make me who I am.',
  },

  { strength: 'Teamwork', question: 'I always do my share of the work.' },
  {
    strength: 'Teamwork',
    question: 'I am very loyal to my group, team, or community.',
  },
  { strength: 'Teamwork', question: 'I like to work closely with others.' },
  { strength: 'Teamwork', question: 'I honor choices made by the group.' },
  {
    strength: 'Teamwork',
    question: 'I always stand by and show support to my teammates.',
  },

  { strength: 'Zest', question: 'I am highly energetic.' },
  { strength: 'Zest', question: 'I use my energy to the fullest degree.' },
  { strength: 'Zest', question: 'Others see me as enthusiastic.' },
  {
    strength: 'Zest',
    question: 'I see my life as exciting and interesting.',
  },
  { strength: 'Zest', question: 'I wake up excited to begin each day.' },
]
